import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const MessageCircleX: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M7.9 20A9 9 0 1 0 4 16.1L2 22Z' }],
    ['path', { d: 'm15 9-6 6' }],
    ['path', { d: 'm9 9 6 6' }],
  ],
];

export default MessageCircleX;
